import React, { useState, useEffect } from "react";
import volumeUp from "../../../assets/font-awesome/white/png/128/volume-up.png";
import stop from "../../../assets/font-awesome/white/png/128/stop-circle.png";
import Bowser from "bowser";
import PD_START from "../../../assets/PD_START.WAV";
import PD_END from "../../../assets/PD_END.WAV";
import n_1 from "../../../assets/0001.WAV";
import n_2 from "../../../assets/0002.WAV";
import n_3 from "../../../assets/0003.WAV";
import n_4 from "../../../assets/0004.WAV";
import n_5 from "../../../assets/0005.WAV";
import n_6 from "../../../assets/0006.WAV";
import n_7 from "../../../assets/0007.WAV";
import n_8 from "../../../assets/0008.WAV";
import n_9 from "../../../assets/0009.WAV";
import n_10 from "../../../assets/0010.WAV";
import n_11 from "../../../assets/0011.WAV";
import n_12 from "../../../assets/0012.WAV";
import n_13 from "../../../assets/0013.WAV";
import n_14 from "../../../assets/0014.WAV";
import n_15 from "../../../assets/0015.WAV";
import n_16 from "../../../assets/0016.WAV";
import n_17 from "../../../assets/0017.WAV";
import n_18 from "../../../assets/0018.WAV";
import n_19 from "../../../assets/0019.WAV";
import n_20 from "../../../assets/0020.WAV";
import n_21 from "../../../assets/0021.WAV";
import n_22 from "../../../assets/0022.WAV";
import n_23 from "../../../assets/0023.WAV";
import n_24 from "../../../assets/0024.WAV";
import n_25 from "../../../assets/0025.WAV";
import n_26 from "../../../assets/0026.WAV";
import n_27 from "../../../assets/0027.WAV";
import n_28 from "../../../assets/0028.WAV";
import n_29 from "../../../assets/0029.WAV";
import n_30 from "../../../assets/0030.WAV";

const TextToSpeech = ({ text }) => {
    const [isPaused, setIsPaused] = useState(false);
    const [utterance, setUtterance] = useState(null);
    const [voice, setVoice] = useState(null);
    const [pitch, setPitch] = useState(1);
    const [rate, setRate] = useState(1);
    const [volume, setVolume] = useState(1);
    let audio;
    let myTimeout1;
    let myTimeout2;

    useEffect(() => {
        const synth = window.speechSynthesis;
        const u = new SpeechSynthesisUtterance(text);
        setUtterance(u);

        const voices = synth.getVoices();
        setVoice(voices[0]);
        setVoice(voices.find((v) => v.name === "Google Bahasa Indonesia"));
        setPitch(parseFloat(0.8));
        setRate(parseFloat(0.7));

        // Add an event listener to the speechSynthesis object to listen for the voiceschanged event
        synth.addEventListener("voiceschanged", () => {
            const voices = synth.getVoices();
            setVoice(voices[0]);

            let x = "Microsoft Gadis Online (Natural) - Indonesian (Indonesia)";
            if (voices.find((v) => v.name === x)) {
                setVoice(voices.find((v) => v.name === x));
            } else {
                setVoice(voices.find((v) => v.name === "Google Bahasa Indonesia"));
            }

            setPitch(parseFloat(0.8));
            setRate(parseFloat(0.7));
        });

        return () => {
            synth.cancel();
            synth.removeEventListener("voiceschanged", () => {
                setVoice(null);
            });
        };
    }, [text]);

    const playAudio = (src) => {
        pauseAudio();
        audio = new Audio();
        audio.src = src;
        audio.play();
    }

    const pauseAudio = () => {
        // If audio is not undefined and if is playing, pause it
        if (audio && !audio.paused) {
            audio.pause();
            audio.currentTime = 0; // Rewind track to beginning (is you need this)

            clearTimeout(myTimeout1);
            clearTimeout(myTimeout2);
        }



    }

    const handlePlay = () => {
        // alert(text.KODE_KONSULTASI);
        // const synth = window.speechSynthesis;

        // if (isPaused) {
        //     synth.resume();
        // } else {
        //     utterance.voice = voice;
        //     utterance.pitch = pitch;
        //     utterance.rate = rate;
        //     utterance.volume = volume;
        //     synth.speak(utterance);
        // }

        // setIsPaused(false);

        let no_antrian = text.ANTRIAN_DOKTER.match(/\d+/g);

        if (text.KODE_KONSULTASI == "PD") {
            // new Audio(PD_START).play();

            playAudio(PD_START)

            myTimeout1 = setTimeout(() => {
                handleNoAntrian(no_antrian);
            }, 3100);

            myTimeout2 = setTimeout(() => {
                // new Audio(PD_END).play();
                playAudio(PD_END)
            }, 5000);

        }


    };

    const handleNoAntrian = (no_antrian) => {

        if (no_antrian == "0001") {
            // new Audio(n_1).play();
            playAudio(n_1);
        } else if (no_antrian == "0002") {
            // new Audio(n_2).play();
            playAudio(n_2);
        } else if (no_antrian == "0003") {
            // new Audio(n_3).play();
            playAudio(n_3);
        } else if (no_antrian == "0004") {
            // new Audio(n_4).play();
            playAudio(n_4);
        } else if (no_antrian == "0005") {
            // new Audio(n_5).play();
            playAudio(n_5);
        } else if (no_antrian == "0006") {
            // new Audio(n_6).play();
            playAudio(n_6);
        } else if (no_antrian == "0007") {
            // new Audio(n_7).play();
            playAudio(n_7);
        } else if (no_antrian == "0008") {
            // new Audio(n_8).play();
            playAudio(n_8);
        } else if (no_antrian == "0009") {
            // new Audio(n_9).play();
            playAudio(n_9);
        } else if (no_antrian == "0010") {
            // new Audio(n_10).play();
            playAudio(n_10);
        } else if (no_antrian == "0011") {
            // new Audio(n_11).play();
            playAudio(n_11);
        } else if (no_antrian == "0012") {
            // new Audio(n_12).play();
            playAudio(n_12);
        } else if (no_antrian == "0013") {
            // new Audio(n_13).play();
            playAudio(n_13);
        } else if (no_antrian == "0014") {
            // new Audio(n_14).play();
            playAudio(n_14);
        } else if (no_antrian == "0015") {
            // new Audio(n_15).play();
            playAudio(n_15);
        } else if (no_antrian == "0016") {
            // new Audio(n_16).play();
            playAudio(n_16);
        } else if (no_antrian == "0017") {
            // new Audio(n_17).play();
            playAudio(n_17);
        } else if (no_antrian == "0018") {
            // new Audio(n_18).play();
            playAudio(n_18);
        } else if (no_antrian == "0019") {
            // new Audio(n_19).play();
            playAudio(n_19);
        } else if (no_antrian == "0020") {
            // new Audio(n_20).play();
            playAudio(n_20);
        } else if (no_antrian == "0021") {
            // new Audio(n_21).play();
            playAudio(n_21);
        } else if (no_antrian == "0022") {
            // new Audio(n_22).play();
            playAudio(n_22);
        } else if (no_antrian == "0023") {
            // new Audio(n_23).play();
            playAudio(n_23);
        } else if (no_antrian == "0024") {
            // new Audio(n_24).play();
            playAudio(n_24);
        } else if (no_antrian == "0025") {
            // new Audio(n_25).play();
            playAudio(n_25);
        } else if (no_antrian == "0026") {
            // new Audio(n_25).play();
            playAudio(n_26);
        } else if (no_antrian == "0027") {
            // new Audio(n_25).play();
            playAudio(n_27);
        } else if (no_antrian == "0028") {
            // new Audio(n_25).play();
            playAudio(n_28);
        } else if (no_antrian == "0029") {
            // new Audio(n_25).play();
            playAudio(n_29);
        } else if (no_antrian == "0030") {
            // new Audio(n_25).play();
            playAudio(n_30);
        } else { }

    };

    const handlePause = () => {
        const synth = window.speechSynthesis;
        setIsPaused(true);
        synth.pause();
    };

    const handleStop = () => {
        const synth = window.speechSynthesis;
        setIsPaused(false);
        synth.cancel();
    };

    const handleVoiceChange = (event) => {
        const voices = window.speechSynthesis.getVoices();
        setVoice(voices.find((v) => v.name === event.target.value));
    };

    const handlePitchChange = (event) => {
        setPitch(parseFloat(event.target.value));
    };

    const handleRateChange = (event) => {
        setRate(parseFloat(event.target.value));
    };

    const handleVolumeChange = (event) => {
        setVolume(parseFloat(event.target.value));
    };

    return (
        <div style={{ display: 'flex' }}>
            {/* <label>
                Voice:
                <select value={voice?.name} onChange={handleVoiceChange}>
                    {window.speechSynthesis.getVoices().map((voice) => (
                        <option key={voice.name} value={voice.name}>
                            {voice.name}
                        </option>
                    ))}
                </select>
            </label>

            <br />

            <label>
                Pitch:
                <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.1"
                    value={pitch}
                    onChange={handlePitchChange}
                />
            </label>

            <br />

            <label>
                Speed:
                <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.1"
                    value={rate}
                    onChange={handleRateChange}
                />
            </label>
            <br />
            <label>
                Volume:
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    value={volume}
                    onChange={handleVolumeChange}
                />
            </label> */}

            {/* <br /> */}

            {/* <button onClick={handlePlay}>{isPaused ? "Resume" : "Play"}</button>
            <button onClick={handlePause}>Pause</button>
            <button onClick={handleStop}>Stop</button> */}

            {/* <button
                className="btn btn-info btn-sm rounded-0"
                type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Play"
                onClick={handlePlay}
            >
                <img src={volumeUp} width="140"/>
            </button> */}
            {/* <ul className="list-inline m-0 d-flex justify-content-center">
                <li className="list-inline-item">
                    <button onClick={handlePlay} className="btn btn-success btn-sm rounded-0" style={{ backgroundImage: "url(" + volumeUp + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}></button>
                </li>
                <li className="list-inline-item">
                    <button onClick={handleStop} className="btn btn-danger btn-sm rounded-0" style={{ backgroundImage: "url(" + stop + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}></button>
                </li>
            </ul> */}

            <button onClick={handlePlay} className="btn btn-success btn-sm rounded-0" style={{ backgroundImage: "url(" + volumeUp + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px", marginRight: '7px' }}></button>
            <button onClick={pauseAudio} className="btn btn-danger btn-sm rounded-0" style={{ backgroundImage: "url(" + stop + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px", marginRight: '7px' }}></button>
        </div>
    );
};

export default TextToSpeech;
